import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class PracticeSpecialtiesInfo extends ModelMixin() implements Model<PracticeSpecialtiesInfo> {

    TYPE = PracticeSpecialtiesInfo;
    static projectionInformation = new ProjectionInformation('practiceSpecialtiesInfo');

    public primary: string;
    public secondary: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/practice-specialties-info.model.ts